import {z as zod} from "zod";

export type CommerceTransactionsWorkspaceCapabilityConfiguration = Record<string, never>;

export const commerceTransactionsWorkspaceCapabilityConfigurationValidator: zod.ZodType<CommerceTransactionsWorkspaceCapabilityConfiguration> = zod.strictObject({});
